export enum OauthUserEvents {
    ClickMcpNavItem = "Oauth - Click MCP Nav Item",
    ClickSettingsNavItem = "Oauth - Click Settings Nav Item",
    ReadMcpSetupDocs = "Oauth - Read MCP Setup Docs",
    ClickNewOAuthClient = "Oauth - Click New OAuth Client",
}
